/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Gray_Wolf_DashInputs */

const en_quick_gray_wolf_dash = /** @type {(inputs: Quick_Gray_Wolf_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save with name`)
};

const de_quick_gray_wolf_dash = /** @type {(inputs: Quick_Gray_Wolf_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern mit Name`)
};

/**
* | output |
* | --- |
* | "Save with name" |
*
* @param {Quick_Gray_Wolf_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_gray_wolf_dash = /** @type {((inputs?: Quick_Gray_Wolf_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Gray_Wolf_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quick_gray_wolf_dash(inputs)
	return de_quick_gray_wolf_dash(inputs)
});